import React, { useState } from "react";
import { Box, Card, CardContent, CardHeader, Typography } from '@mui/material';
import HighRiskTable from "./components/HighRiskTable";
import { useTranslation } from "react-i18next";

const HighRiskPanel = () => {
  const { t } = useTranslation();
  const [selectedLocation, setSelectedLocation] = useState("");

  return (
    <Box sx={{ padding: '10px', width: '100%' }}>
      {/* Table with location filter */}
      <Card elevation={3} sx={{ mt: 2 }}>
        <CardHeader
          title={
            <Typography
              variant="h5"
              component="div"
              sx={{
                color: 'primary.main',
                fontWeight: 'bold',
              }}
            >
              {t("HighRiskInformation.HighRiskInformation")}
            </Typography>
          }
        />
        <CardContent>
          <HighRiskTable
            selectedLocation={selectedLocation}
            setSelectedLocation={setSelectedLocation}
          />
        </CardContent>
      </Card>
    </Box>
  );
};

export default HighRiskPanel;
